// Libraries
import { Box, Tab, Tabs } from "@material-ui/core";
import React, { useState } from "react";
import { matchPath, useLocation } from "react-router-dom";
import styled from "styled-components";

// Custom
import { StoresInstance } from "Globals/Stores/Stores";
import { INavLinkOption } from "./LogEntry";

export const StyledTabs = styled(Tabs)`
    color: #222222;
    margin-bottom: 30px;
    button {
        background-color: #ededed;
        text-transform: none;
        border-left: 1px solid #ffffff;
        border-top: 1px solid #ffffff;
        border-bottom: 1px solid #ffffff;
        margin: 5px 0 0 0;
        opacity: 1;
        padding: 9px 7px;
        :last-child {
            border-right: 1px solid #ffffff;
        }
        border-radius: 0px;
    }
    button.Mui-selected {
        background-color: #ffffff;
        border-bottom: 1px solid #ffffff;
    }
    & span.MuiTabs-indicator {
        display: none;
    }
`;

interface IProps {
    navLinkOptions: INavLinkOption[];
    tabValue: number;
    setTabValue: (value: number) => void;
}

const domainStores = StoresInstance.Domain;

export const TabNavigationBar: React.FC<IProps> = (props: IProps) => {
    const { navLinkOptions, tabValue, setTabValue } = props;
    return (
        <StyledTabs value={tabValue}>
            {navLinkOptions.map((o, i) => {
                return <Tab label={o.name} onClick={() => setTabValue(o.value)} value={o.value} key={i} />;
            })}
        </StyledTabs>
    );
};
